/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

          var baseFormat = function(value) {
              return value.replace(/[^0-9]/g, '').split('').reverse().join('')
                  .replace(/([0-9][0-9][0-9])/g, '$1 ').split('').reverse().join('')
                  .replace(/(^\s*)|(\s*$)/gi, '');
          };

          $('#kwota-kredytu-visible, #cena-netto-visible').keyup(function(event) {
              var $this = $(this);
              $this.val(baseFormat($this.val()));
          });

          $('#kwota-kredytu-visible').change(function() {
              $('#kwota-kredytu').val($('#kwota-kredytu-visible').val().replace(/ /g,''));
          });

          $('#cena-netto-visible').change(function() {
              $('#cena-netto').val($('#cena-netto-visible').val().replace(/ /g,''));
          });

              $( "#credit-calc" ).validate({
                  rules: {
                      "cena-netto-visible": {
                          required: true,


                      },
                      "kwota-kredytu-visible": {
                          required: true,


                      }
                  },
                  messages: {
                      "cena-netto-visible": {
                          required: "Podanie ceny pojazdu jest wymagane.",

                      },
                      "kwota-kredytu-visible": {
                          required: "Podanie kwoty kredytu jest wymagane",

                      }
                  }
              });

              $.validator.addMethod("greaterThan",
                  function (value, element, param) {
                      var $otherElement = $(param);
                      return parseInt(value, 10) >= parseInt($otherElement.val(), 10);
                  });

              jQuery.fn.ForceNumericOnly =
                  function()
                  {
                      this.keyup(function(e)
                      {
                          $(this).val($(this).val().replace(/,/g,"."));
                      });
                  };

              $("#cena-netto, #kwota-kredytu").ForceNumericOnly();


              // nie dzialalo bo bylo zdefiniowane przed includowaniem bibliotek trzeba to sprawdzic
              jQuery('.wpcf7').on('wpcf7:submit', function (event) {
                  event.preventDefault(); // Now link won't go anywhere
                  event.stopPropagation(); // Now the event won't bubble up

                  event.stopImmediatePropagation();
                  if ( $('#terms').is(":checked") ) {
                      event.preventDefault(); // Now link won't go anywhere
                      event.stopPropagation(); // Now the event won't bubble up

                      event.stopImmediatePropagation();
                  }

              });

              $('#terms').on('change', function() {
                  var isChecked = $(this).is(":checked");
                  var submitBtn = $('#contactModal').find('.wpcf7-submit');

                  if (isChecked) {
                      submitBtn.removeClass('disabled');
                  } else {
                      submitBtn.addClass('disabled');
                  }
              });

              //triggered when modal is about to be shown
              $('#contactModal').on('show.bs.modal', function(e) {

                  //get data-id attribute of the clicked element
                  var bankName = $(e.relatedTarget).data('bank-name');


                  //populate the textbox
                  $(e.currentTarget).find('.modal-subtitle').text(bankName);
                  $(e.currentTarget).find('input#bank-name').val(bankName);
              });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        function setCookie(b, a, c) {
          var d = new Date;
          d.setDate(d.getDate() + c);
          a = escape(a) + (null == c ? "" : "; expires=" + d.toUTCString());
          document.cookie = b + "=" + a
        }

        function getCookie(b) {
          var a, c, d, e = document.cookie.split(";");
          for (a = 0; a < e.length; a++)
            if (c = e[a].substr(0, e[a].indexOf("=")), d = e[a].substr(e[a].indexOf("=") + 1), c = c.replace(/^\s+|\s+$/g, ""), c == b) return unescape(d)
        }
        var cookieEnabled = navigator.cookieEnabled ? !0 : !1;
        "undefined" == typeof navigator.cookieEnabled && !cookieEnabled && (document.cookie = "testcookie", cookieEnabled = -1 != document.cookie.indexOf("testcookie") ? !0 : !1);
        window.onload = function () {
          if (cookieEnabled && !getCookie("cookie-info")) {
            $('.cookie-info').removeClass('hidden');

            $('.cookie-info .right a').on('click',function () {
              setCookie("cookie-info", !0, 365);
              $('.cookie-info').addClass('hidden');
            });
          }
        };
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
